import React, { Component } from "react"
import { connect } from 'react-redux';
import { AppState } from '../../../store'
import Employees from "../../../pages/hr/Employees/Employees";
import "./MyPto.css"

interface MyPtoProps {
    userId: string | number
}

class MyPto extends Component<MyPtoProps, {}> {

    componentDidMount() {
        this.openDetails()
    }

    //!!!!!bk 8-22-22 this is a temporary fix
    openDetails = () => {
        let elem = document.getElementById(`hacky-fix-${this.props.userId}`)
        if (elem) {
            elem.click()
        } else {
            setTimeout(() => {
                this.openDetails()
            }, 100);
        }
    }

    render() {

        return (
            <div className="MyPto main-content col-sm">
                <Employees
                    singleDetail={this.props.userId}
                    activeKey="MyPto"
                />
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
})

export default connect(mapStateToProps)(MyPto)